import { render, staticRenderFns } from "./AreaPivotCreate.vue?vue&type=template&id=20372fd4"
import script from "./AreaPivotCreate.vue?vue&type=script&lang=js"
export * from "./AreaPivotCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports